import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Table from "./Table"
import { FiltersCard } from "components/Common/FiltersCard"
import axios from "axios"
import {API_URL, sitename} from "constants/constants"
import { showErrorMessages } from "helpers/helpers"
import {showMessage} from "../../../components/Common/Toaster";
import "../../../assets/table.css";
import TableLoader from "../../../components/Common/TableLoader";
import moment from "moment";
const SportsTickets = props => {
    const [item, setItem] = useState("All")
    const [fromDate, setFromDate] =useState(moment().format("YYYY-MM-DD"))
    const [liveData, setLive] = useState("prematch")
    const [toDate, setToDate] =useState(moment().format("YYYY-MM-DD"))
    const [total, setTotal] =useState(0)
    const [nextPageUrl, setNextPageUrl] =useState("")
    const [prevPageUrl, setPrevPageUrl] =useState("")
    const [callUrl, setCallUrl] =useState("")
    const [loadingMessage, setLoadingMessage] = useState("1");
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const [filtersData, setFiltersData] = useState({
        item: "",
        fromDate: "",
        toDate: "",
    })
    const [data, setData] = useState([])
    const [modelData, setModalData] = useState([])
    const options = [
        { label: "Lost", value: "Lost" },
        { label: "Won", value: "Won" },
        { label: "All", value: "All" },
        { label: "Pending", value: "Pending" },
        { label: "Void", value: "Void" },
        { label: "Cashout", value: "cashout" },
    ]

    useEffect(() => {
        call()
    }, [])

    const call = () => {
        setLoadingMessage("1");
        axios({
            method: "get",
            url: `${API_URL}/admin/reports/sport-tickets?to=${toDate}&from=${fromDate}&type=${item}&match_type=${liveData}`,
        })
            .then(function (response) {
                setData(response?.data?.data?.data)
                setTotal(response?.data?.data?.total)
                setNextPageUrl(response?.data?.data?.next_page_url)
                setCurrentPage(response?.data?.data?.current_page)
                setLastPage(response?.data?.data?.last_page)

                setLoadingMessage("0");
            })
            .catch(function (response) {})
    }

    $(document).off('click').on("click","ul.pagination li a",function(e) {
        e.preventDefault();
        e.stopPropagation();
        setLoadingMessage("1");

        var page = $(this).text();
        if(page=='>'){
            if(currentPage<lastPage){
                console.log("yes")
                page = currentPage + 1;
            }
        }
        if(page=='>>'){
                page = lastPage;
        }
        if(page=='<'){
            if(currentPage>1){
                page = currentPage - 1;
            }
        }



        axios({
            method: "get",
            url: `${API_URL}/admin/reports/sport-tickets?page=${page}&to=${toDate}&from=${fromDate}&type=${item}&match_type=${liveData}`,
        })
            .then(function (response) {
                setData(response?.data?.data?.data)
                setTotal(response?.data?.data?.total)
                setNextPageUrl(response?.data?.data?.next_page_url)
                setPrevPageUrl(response?.data?.data?.prev_page_url)
                setLastPage(response?.data?.data?.last_page)
                setCurrentPage(response?.data?.data?.current_page)
                var current = response?.data?.data?.current_page;
                setLoadingMessage("0");


                $('ul.pagination li').removeClass('active');
                $('ul.pagination li[title="'+current+'"]').addClass('active');
                if(current>1){
                    $('.pagination.react-bootstrap-table-page-btns-ul li[title="first page"]').removeClass('disabled');
                    $('.pagination.react-bootstrap-table-page-btns-ul li[title="previous page"]').removeClass('disabled');
                }else{
                    $('.pagination.react-bootstrap-table-page-btns-ul li[title="first page"]').addClass('disabled');
                    $('.pagination.react-bootstrap-table-page-btns-ul li[title="previous page"]').addClass('disabled');
                }
            })
            .catch(function (response) {})



    });
    const callById =id => {
        axios({
            method: "get",
            url: `${API_URL}/admin/reports/sport-tickets?id=${id}&match_type=${liveData}&unsetPagination=${true}`,
        })
            .then(function (response) {
                setModalData(response?.data?.data[0])
            })
            .catch(function (response) {})
    }

    const cancelTicketCall = (id) => {
        axios({
            method: "get",
            url: `${API_URL}/admin/reports/cancel-tickets/${id}`,
        })
            .then(function (response) {
                showMessage("success", response.data.message)
                call();
            })
            .catch(function (response) {
                showErrorMessages(response)
            })
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{sitename}</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs title="Admin" breadcrumbItem="Sports Tickets" />
                </Container>
                <FiltersCard
                    item={item}
                    setItem={setItem}
                    options={options}
                    fromDate={fromDate}
                    toDate={toDate}
                    setToDate={setToDate}
                    setFromDate={setFromDate}
                    showToDate={true}
                    setFiltersData={setFiltersData}
                    call={() => {
                        call()
                    }}
hideShowType={false}
                />
                <Table data={data}
                       modelData={modelData}
                       liveData={liveData}
                       setLive={setLive}
                       callById={(id) => {
                           callById(id)
                       }}
                       call={() => {
                           call()
                       }}
                       cancelTicketCall={(id) => {
                           cancelTicketCall(id)
                       }}
                       item={item}
                       toDate={toDate}
                       fromDate={fromDate}
                       loadingMessage={loadingMessage}
                       setLoadingMessage={setLoadingMessage}
                       setTotal = {setTotal}
                       total = {total}
                       currentPage ={currentPage}
                       setCallUrl ={setCallUrl}
                       setPrevPageUrl = {setPrevPageUrl}
                       prevPageUrl = {prevPageUrl}
                       nextPageUrl = {nextPageUrl}
                       setNextPageUrl = {setNextPageUrl}
                />

            </div>
        </React.Fragment>
    )
}

export default withRouter(SportsTickets)
